import React from 'react'
import { ReactComponent as AlertTriangleSvg } from './assets/alert-triangle.svg'
import { ReactComponent as ArrowLeftSvg } from './assets/arrow-left.svg'
import { ReactComponent as BackspaceSvg } from './assets/backspace.svg'
import { ReactComponent as BedSvg } from './assets/bed.svg'
import { ReactComponent as ChevronRightSvg } from './assets/chevron-right.svg'
import { ReactComponent as HashSvg } from './assets/hash.svg'
import { ReactComponent as SearchSvg } from './assets/search.svg'
import { ReactComponent as ShieldCheckSvg } from './assets/shield-check.svg'
import { ReactComponent as UserSvg } from './assets/user.svg'
import { ReactComponent as UsersSvg } from './assets/users.svg'
import { ReactComponent as CheckCircleSvg } from './assets/check-circle.svg'
import { ReactComponent as EraserSvg } from './assets/eraser.svg'
import { ReactComponent as LoaderSvg } from './assets/loader.svg'

const ICONS = {
	'alert-triangle': AlertTriangleSvg,
	'arrow-left': ArrowLeftSvg,
	backspace: BackspaceSvg,
	bed: BedSvg,
	'chevron-right': ChevronRightSvg,
	hash: HashSvg,
	search: SearchSvg,
	'shield-check': ShieldCheckSvg,
	user: UserSvg,
	users: UsersSvg,
	'check-circle': CheckCircleSvg,
	eraser: EraserSvg,
	loader: LoaderSvg,
}

const RoomChargeIcon = React.memo(({ icon, className }) => {
	const Icon = ICONS[icon]

	return Icon ? <Icon aria-hidden="true" focusable="false" className={className} /> : null
})

RoomChargeIcon.displayName = 'RoomChargeIcon'
export default RoomChargeIcon
